import React from 'react';
import {useField} from 'formik';
import {t} from 'ttag';
import {Toggle} from '../../../../../../form/form.jsx';

const SyncInMsgActions = () => {
  const [field, , helpers] = useField('sync_in_msg_actions');

  return (
    <Toggle
      label={t`Displaying deleted and edited messages as in WhatsApp`}
      onChange={helpers.setValue}
      isChecked={field.value}
    />
  );
};

export default SyncInMsgActions;
